export enum ApplicationStatus {
  CLOSED = 'CLOSED',
  DENIED = 'DENIED',
  STARTED = 'STARTED',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  INTERVIEW = 'INTERVIEW',
  IN_REVIEW = 'IN_REVIEW'
}

export const orderedApplicationStatus = [
  ApplicationStatus.STARTED,
  ApplicationStatus.COMPLETED,
  ApplicationStatus.INTERVIEW,
  ApplicationStatus.IN_REVIEW,
  ApplicationStatus.APPROVED,
  ApplicationStatus.DENIED,
  ApplicationStatus.CLOSED
]

export const applicationStatusToString = (status: ApplicationStatus) => {
  const stringsObject = {
    [ApplicationStatus.CLOSED]: 'Closed',
    [ApplicationStatus.DENIED]: 'Denied',
    [ApplicationStatus.STARTED]: 'Incomplete',
    [ApplicationStatus.APPROVED]: 'Approved',
    [ApplicationStatus.COMPLETED]: 'Open',
    [ApplicationStatus.INTERVIEW]: 'Interview',
    [ApplicationStatus.IN_REVIEW]: 'In Review'
  }

  return stringsObject[status]
}


// WEBPACK FOOTER //
// ./src/lib/interfaces/ApplicationStatus.interface.ts